export const wincAppDomain = 'winc.app.readcloud.com';
export const webAppDomain = 'app.readcloud.com';
